export default __webpack_public_path__ + "static/media/paperplane.1317c04f.svg";